import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { Observable } from 'rxjs';
import { IElementDetailsViewModel, IElementDetailsDynamicInputModel, IElementDetailsDynamicOutputModel } from 'src/app/ViewModel/ElementDetailsModel';

@Injectable({
  providedIn: 'root'
})
export class ElementdetailsService {

  private getElementDetailsListUrl = 'ElementDetails/GetElementDetailsList';
  private getElementDetailsByDescListUrl = 'ElementDetails/GetElementDetailsByDescList';
  private insertUpdateElementDetailsUrl = 'ElementDetails/InsertUpdateElementDetailsList';
  private CopyElementDetailsUrl = 'ElementDetails/CopyElementDetails';
  private getElementDetailsDynamicUrl = 'ElementDetails/GetElementDetailsDynamic';

  constructor(private restAPTService: RestApiService) { }


  /**
   * Get Elements List API
   * @param de_Id 50
   * @param ded_Id 50
   */
  public GetElementDetailsList(de_Id?: number, ded_Id?: number): Observable<IElementDetailsViewModel[]> {
    let reqData = {
      'de_Id': de_Id,
      'ded_Id': ded_Id
    };
    return this.restAPTService.new_POST(this.getElementDetailsListUrl, reqData);
  }

  /**
   * Insert and Update Element Details
   * @param elementDetails 
   */
  public insertUpdateElementDetails(elementDetails: IElementDetailsViewModel): Observable<any> {
    return this.restAPTService.new_POST(this.insertUpdateElementDetailsUrl, elementDetails);
  }

  /**
   * Get Elements List API
   * @param elementDescription 'CCN Type'
   */
  public GetElementDetailsByDescList(elementDescription: string): Observable<IElementDetailsViewModel[]> {
    let reqData = {
      'elementDescription': elementDescription
    };
    return this.restAPTService.new_POST(this.getElementDetailsByDescListUrl, reqData);
  }

  /**
  * Get Elements List API
  * @param elementDescription 'CCN Type'
  */
  public GetElementDetailsDynamic(inputdata?: IElementDetailsDynamicInputModel): Observable<IElementDetailsDynamicOutputModel[]> {
    return this.restAPTService.new_POST(this.getElementDetailsDynamicUrl, inputdata);
  }

  public CopyElementDetails(input: any): Observable<any> {
    return this.restAPTService.new_POST(this.CopyElementDetailsUrl, input);
  }


}
